import React, {useEffect} from "react";
import bgImg from '../Images/treatments.webp'
import Breadcrumb from "../Components/Breadcrumb";
import TreatmentGrid from "../Components/TreatmentGrid";
import Testimonials from "../Components/Testimonials";
import Cta from "../Components/Cta";
import { treatments } from "../Data";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import TreatmentsCollectionSchema from "../Schema/TreatmentsCollectionSchema";

const TreatmentsCommon=()=>{
useEffect(() => {
        document.title =
          "Authentic Ayurvedic Treatments in Kutch | Dr. Jigar Gor";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Explore authentic Ayurvedic treatments in Kutch by Dr. Jigar Gor, including Panchakarma, skin care, hair care, and holistic wellness therapies."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://msayurved.com/treatments");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Authentic Ayurvedic Treatments in Kutch | Dr. Jigar Gor"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Explore authentic Ayurvedic treatments in Kutch by Dr. Jigar Gor, including Panchakarma, skin care, hair care, and holistic wellness therapies."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://msayurved.com/treatments");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://msayurved.com/Images/treatments.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Authentic Ayurvedic Treatments in Kutch | Dr. Jigar Gor"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Explore authentic Ayurvedic treatments in Kutch by Dr. Jigar Gor, including Panchakarma, skin care, hair care, and holistic wellness therapies."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://msayurved.com/Images/treatments.webp"
        );
      }
      }, []);

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Treatments provided by Dr. Jigar Gor",
      url: "https://msayurved.com/treatments/"
    },
  ];

    return(
        <>

        <BreadcrumbSchema items={breadcrumbItems} />
        <TreatmentsCollectionSchema treatments={treatments} />

         {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Treatments"
        bgImage={bgImg}
        />

        {/**TREATMENTS GRID */}
        <TreatmentGrid />
        
        <div style={{marginBottom:"80px"}}></div>

        {/**TESTIMONIALS */}
        <Testimonials />

        <div style={{marginBottom:"-80px"}}></div>

        {/**CTA */}
        <Cta />
        </>
    )
}
export default TreatmentsCommon;